import React from "react";

import AnnotationDotsIcon from "@uui/AnnotationDots";
import MessageCheckSquareIcon from "@uui/MessageCheckSquare";
import MessageQuestionSquareIcon from "@uui/MessageQuestionSquare";
import NotificationText from "@uui/NotificationText";
import PlaySquareIcon from "@uui/PlaySquare";
import StarsIcon from "@uui/Stars01";
import StickerSquareIcon from "@uui/StickerSquare";

import ClockIcon from "@mui/icons-material/AccessTime";
import DollarIcon from "@mui/icons-material/AttachMoney";
import GraphIcon from "@mui/icons-material/AutoGraph";
import MissedMeetingsIcon from "@mui/icons-material/FilterList";

import { TrendArrowIcon } from "@app/common/assets/icons/Icons";

const ID_TO_ICON: { [key: string]: React.ReactElement } = {
  time: <ClockIcon />,
  dollar: <DollarIcon />,
  missedMeetings: <MissedMeetingsIcon />,
  graph: <GraphIcon />,
  trendDown: <TrendArrowIcon direction={-1} />,
  trendUp: <TrendArrowIcon direction={1} />,
  trendNeutral: <TrendArrowIcon direction={0} />,
};

export const getIconById = (id: string | undefined) =>
  id ? ID_TO_ICON[id] : undefined;

export type IconCategory =
  | "action_items"
  | "clips"
  | "key_questions"
  | "notes"
  | "summary"
  | "topics"
  | "what_you_missed";

export type IconConfig = {
  Icon: typeof StarsIcon;
  bgcolor: React.CSSProperties["backgroundColor"];
  color: React.CSSProperties["color"];
};

export const ICON_BY_CATEGORY: {
  [key in IconCategory]: IconConfig;
} = {
  action_items: {
    Icon: MessageCheckSquareIcon,
    bgcolor: "shades.primary.50",
    color: "shades.primary.400",
  },
  clips: {
    Icon: PlaySquareIcon,
    bgcolor: "avatar.yellowGreen.main",
    color: "avatar.yellowGreen.dark",
  },
  key_questions: {
    Icon: MessageQuestionSquareIcon,
    bgcolor: "shades.orange.100",
    color: "chart.orange.dark",
  },
  notes: {
    Icon: StickerSquareIcon,
    bgcolor: "shades.emerald.100",
    color: "shades.emerald.600",
  },
  summary: {
    Icon: StarsIcon,
    bgcolor: "shades.primary.50",
    color: "shades.secondary.500",
  },
  topics: {
    Icon: AnnotationDotsIcon,
    bgcolor: "#D9F4F8",
    color: "chart.teal.dark",
  },
  what_you_missed: {
    Icon: NotificationText,
    bgcolor: "shades.blush.100",
    color: "shades.blush.500",
  },
};
